import React from 'react';
import styles from './VirtualReceptionist.module.css';

const VirtualReceptionist = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>How to set up your virtual receptionist?</h2>
      <p className={styles.intro}>
        Setting up your virtual receptionist is quick and easy, allowing your business to handle customer calls automatically, 24/7. Follow these steps to configure your AI-powered assistant:
      </p>

      <div className={styles.step}>
        <h3>Create Your Account</h3>
        <p>Sign up on the platform (e.g., toxboxai.com) with your basic details. Once verified, you’ll gain access to your dashboard.</p>
      </div>

      <div className={styles.step}>
        <h3>Set a Greeting Message</h3>
        <p>Customize the welcome message your customers hear when they call. Example: “Hi! Thanks for calling [Your Business]. How can I help you today?”</p>
      </div>

      <div className={styles.step}>
        <h3>Configure Call Flow</h3>
        <p>Define what happens during a call:</p>
        <ul className={styles.list}>
          <li>Answer FAQs automatically</li>
          <li>Route to the right department</li>
          <li>Collect caller info (like name, issue, or appointment request)</li>
          <li>Transfer to a live agent if needed</li>
        </ul>
      </div>

      <div className={styles.step}>
        <h3>Choose Operating Hours</h3>
        <p>Set the availability for live agents and let the AI handle off-hours.</p>
      </div>

      <div className={styles.step}>
        <h3>Test the System</h3>
        <p>Make a few test calls to ensure everything sounds and works the way you want.</p>
      </div>

      <div className={styles.step}>
        <h3>Go Live!</h3>
        <p>Once satisfied, publish your call flow and let the AI receptionist start answering calls on your behalf.</p>
      </div>
    </div>
  );
};

export default VirtualReceptionist;
